import axios from 'axios';
import { API_BASE_URL } from '../../../../lib/constants';

export const fetchPreOpOrderData = async (uhid_no) => {
    const response = await axios.get(`${API_BASE_URL}/get_preop_order/${uhid_no}`);
    return response.data;
};

export const fetchPatientData = async (uhid_no) => {
    const response = await axios.get(`${API_BASE_URL}/get_patient/${uhid_no}`, {
        withCredentials: true,
    });
    return response.data;
};

export const fetchPreOpOrderNextIp = async () => {
    const response = await axios.get(`${API_BASE_URL}/get_preop_order_next_ip`);
    return response.data;
};

export const fetchAllPatients = async () => {
    const response = await axios.get(`${API_BASE_URL}/get_all_patients`, {
        withCredentials: true,
    });
    return response.data;
};

export const savePreOpOrder = async (data) => {
    const response = await axios.post(`${API_BASE_URL}/preop_form_submit`, data, { withCredentials: true });
    return response.data;
};

export const updatePreOpOrder = async (uhid_no, data) => {
    const response = await axios.put(`${API_BASE_URL}/update_preop_order/${uhid_no}`, data, { withCredentials: true });
    return response.data;
};

export const sendPreOpNotification = async (emailData) => {
    const response = await axios.post(`${API_BASE_URL}/send_preop_notification`, emailData);
    return response.data;
};
